import { useEffect, Component } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { CtaBand } from "@/components/CtaBand";
import { Strengths } from "@/components/Strengths";
import { Services } from "@/components/Services";
import { ScreenFree } from "@/components/ScreenFree";
import { NightCare } from "@/components/NightCare";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StickyCta } from "@/components/StickyCta";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
          <div>
            <p className="font-serif text-3xl text-petrol">Hetkinen – jokin meni pieleen.</p>
            <p className="mt-3 text-mutedink">Päivitä sivu, niin jatketaan.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen bg-cream text-ink">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Testimonials />
          <CtaBand />
          <Strengths />
          <Services />
          <ScreenFree />
          <NightCare />
          <Contact />
        </main>
        <Footer />
        <StickyCta />
        <WhatsAppFloat />
      </div>
    </ErrorBoundary>
  );
}

export default App;
